<template>
  <slide-view
    modal
    appendToBody
    modalAppendToBody
    v-empty="!canShowDetail"
    :listener-ids="listenerIDs"
    :no-listener-ids="noListenerIDs"
    :no-listener-class="noListenerClass"
    :body-style="{padding: 0, height: id ? '100%' : '100vh'}"
    xs-empty-icon="nopermission"
    xs-empty-text="暂无权限"
    :slide-fade="id?'slide-fade':''"
    @afterEnter="viewAfterEnter"
    @close="hideView">
    <div
      ref="crmDetailMain"
      v-loading="loading"
      class="detail-main no-padding">
      <flexbox
        v-if="canShowDetail && detailData"
        direction="column"
        align="stretch"
        class="d-container">
        <c-r-m-detail-head
          :id="detailId"
          :class="{'is-shadow': bodyIsScroll}"
          :detail="detailData"
          :is-seas="isSeasDetail"
          :pool-id="seasPoolId"
          :pool-auth="poolAuth"
          :handles="activityHandle"
          :model-data="modelData"
          :crm-type="crmType"
          :page-list="pageList"
          :tag-info="tagInfo"
          @pageChange="pageChange"
          @handle="detailHeadHandle"
          @close="hideView">
          <template slot="appreciation-examine">
            <!-- 转为精准联系人 -->
            <el-button
              v-for="(item,index) in examineButtons"
              :key="index"
              class="head-handle-button"
              type="primary"
              @click="handleExamineClick(item)">{{ item.examineName }}</el-button>
          </template>

          <!-- <el-button
            slot="appreciation-call"
            class="wk-premium-info-btn"
            data-type="Call">
            <i class="wk wk-icon-lightning-solid wk-premium-info-icon" data-type="Call" />
            <span class="wk-premium-info-label" data-type="Call">呼叫中心</span>
          </el-button> -->
          <template slot="name">
            <i v-if="detailData.status == 2" class="wk wk-circle-password" />
            <crm-tooltip v-if="!isSeasDetail" :content="detailData.star == 0 ? '添加关注' : '取消关注'" effect="dark" placement="top">
              <i
                v-if="detailData.star == 0"
                class="el-icon-star-off focus-icon"
                @click="toggleStar()" />
              <i
                v-else
                class="wk wk-focus-on focus-icon active"
                @click="toggleStar()" />
            </crm-tooltip>
          </template>
        </c-r-m-detail-head>

        <div class="d-container-body" @scroll="bodyScroll">
          <detail-head-base :list="headDetails" />
          <relative-stage-records
            v-if="statusShow"
            :id="detailId"
            :is-seas="isSeasDetail"
            :crm-type="crmType"
            :detail="detailData"
            @handle="detailHeadHandle"
          />
          <el-tabs
            v-if="pagesInsertComplete"
            v-model="tabCurrentName"
            nav-mode="more"
            class="top-padding">
            <el-tab-pane
              v-for="(item, index) in tabNames"
              :key="index"
              :label="item.label"
              :name="item.name"
              lazy>
              <template slot="label">
                <el-badge
                  :value="item.num"
                  :hidden="item.num <= 0">
                  {{ item.label }}
                </el-badge>
              </template>
              <crm-webview v-if="item.url" :key="index" :iframe-path="item.url" />
              <component
                :is="item.name"
                v-else
                :id="detailId"
                :ref="item.name"
                :is-seas="isSeasDetail"
                :pool-id="seasPoolId"
                :detail="detailData"
                :type-list="logTyps"
                :handle="activityHandle"
                :crm-type="crmType"
                @handle="detailHeadHandle" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </flexbox>
    </div>
    <c-r-m-all-create
      v-if="isCreate"
      :action="{type: 'update', id: detailId, batchId: detailData.batchId, data: actionData}"
      :crm-type="crmType"
      @save-success="editSaveSuccess"
      @close="isCreate=false" />

    <ExamineRemarkDialog
      :show="showExamineRemark"
      title="取消KP审批"
      placeholder="请输入取消理由（必填）"
      @close="showExamineRemark = false"
      @confirm="examineRemarkComplete"
    />
  </slide-view>
</template>

<script>
import { crmContactsReadAPI } from '@/api/crm/contacts'
import { crmSpecialExamineAPI, crmPagesInsertDetailListAPI } from '@/api/crm/common'
import SlideView from '@/components/SlideView'
import CRMDetailHead from '../components/CRMDetailHead'
import Activity from '../components/Activity' // 活动
import ContactsImport from './components/ContactsImport' // 重要信息
import CRMEditBaseInfo from '../components/CRMEditBaseInfo' // 联系人基本信息
import RelativeStageRecords from '../components/RelativeStageRecords' // 阶段记录
import RelativeBusiness from '../components/RelativeBusiness' // 相关商机
import RelativeHandle from '../components/RelativeHandle' // 相关操作
import RelativeFiles from '../components/RelativeFiles' // 相关附件
import RelativeTeam from '../components/RelativeTeam' // 团队成员
import CrmWebview from '../components/Webview/index' // iframe容器
import ExamineRemarkDialog from '../components/ExamineRemarkDialog' // 审批备注弹窗
import CRMAllCreate from '../components/CRMAllCreate' // 新建页面
import DetailMixin from '../mixins/Detail'
import ExamineMixin from '../mixins/Examine'

export default {
  /** 联系人管理 的 联系人详情 */
  name: 'ContactsDetail',
  components: {
    SlideView,
    CRMDetailHead,
    RelativeStageRecords,
    Activity,
    CRMEditBaseInfo,
    RelativeBusiness,
    RelativeHandle,
    RelativeFiles,
    RelativeTeam,
    CRMAllCreate,
    ContactsImport,
    ExamineRemarkDialog,
    CrmWebview
  },
  mixins: [DetailMixin, ExamineMixin],
  props: {
    // 详情信息id
    id: [String, Number],
    poolId: [String, Number],
    // 监听的dom 进行隐藏详情
    listenerIDs: {
      type: Array,
      default: () => {
        return ['crm-main-container']
      }
    },
    // 不监听
    noListenerIDs: {
      type: Array,
      default: () => {
        return []
      }
    },
    noListenerClass: {
      type: Array,
      default: () => {
        return ['el-table__body']
      }
    },
    /** 呼出信息 */
    modelData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      // 展示加载loading
      loading: false,
      crmType: 'contacts',
      headDetails: [],
      tabCurrentName: 'Activity',
      // 编辑操作
      isCreate: false,
      // 审批按钮
      examineButtons: [],
      // 审批信息
      examineInfo: {},
      // 审批备注弹窗
      showExamineRemark: false,
      actionData: {}, // action额外数据
      // 公海规则权限
      poolAuth: {},
      pagesInsertList: [], // tab嵌入页面列表
      pagesInsertComplete: false // 获取嵌入tab是否完成
    }
  },
  computed: {
    /**
     * 活动操作
     */
    activityHandle() {
      const temps = [
        {
          type: 'task',
          label: '创建任务',
          auth: 'oa.taskExamine'
        }, {
          type: 'business',
          label: '创建商机',
          auth: 'crm.business.save'
        }, {
          type: 'contract',
          label: '创建合同',
          auth: 'crm.contract.save'
        }, {
          type: 'receivables',
          label: '创建回款',
          auth: 'crm.receivables.save'
        }
      ]

      // if (this.canCreateFollowRecord) {
      //   temps = [{
      //     type: 'log',
      //     label: '写跟进'
      //   }].concat(temps)
      // }

      return temps
    },

    /**
     * tabs
     */
    tabNames() {
      var tempsTabs = []
      tempsTabs.push({ label: '活动', name: 'Activity' })
      if (this.crm.contacts && this.crm.contacts.read) {
        tempsTabs.push({ label: '详细资料', name: 'CRMEditBaseInfo' })
      }

      tempsTabs.push({ label: '团队成员', name: 'RelativeTeam', num: this.tabsNumber.memberCount })

      const pagesInsertList = this.pagesInsertList
      if (Array.isArray(pagesInsertList) && pagesInsertList.length) {
        tempsTabs = tempsTabs.concat(pagesInsertList.map(item => {
          return { label: item.name, name: item.name, num: 0, url: item.url }
        }))
      }

      if (this.crm.business && this.crm.business.index) {
        tempsTabs.push({ label: '商机', name: 'RelativeBusiness', num: this.tabsNumber.businessCount })
      }
      tempsTabs.push({ label: '附件', name: 'RelativeFiles', num: this.tabsNumber.fileCount })
      tempsTabs.push({ label: '操作记录', name: 'RelativeHandle', num: 0 })

      // if (this.statusShow) {
      //   tempsTabs.unshift({ label: '阶段记录', name: 'RelativeStageRecords' })
      // }
      return tempsTabs
    },
    /**
     * isSeas 是从公海模块传入的 配合详情is_pool字段确定
     */
    isSeasDetail() {
      if (this.detailData && this.detailData.hasOwnProperty('isPool')) {
        return this.detailData.isPool == 1
      }
      return this.isSeas
    },
    /**
     * 公海id
     */
    seasPoolId() {
      if (this.poolAuth && this.poolAuth.poolId) {
        return this.poolAuth.poolId
      }
      return this.poolId
    },

    /**
     * 根据记录筛选
     */
    logTyps() {
      let logTypslist = []
      logTypslist = [{
        icon: 'all',
        color: '#2362FB',
        command: '',
        label: '全部活动'
      }, {
        icon: 'contacts',
        color: '#27BA4A',
        command: 3,
        label: '联系人'
      }, {
        icon: 'o-task',
        color: '#D376FF',
        command: 11,
        label: '任务'
      }, {
        icon: 'log',
        color: '#5864FF',
        command: 8,
        label: '日志'
      }, {
        icon: 'approve',
        color: '#9376FF',
        command: 9,
        label: '审批'
      }]
      if (this.$store.state.crm.isCall) {
        logTypslist.push({
          icon: 'phone',
          color: '#9376FF',
          command: 13,
          label: '呼叫记录'
        })
      }
      return logTypslist
    },

    /**
     * 客户ID
     */
    customerId() {
      return this.detailData ? this.detailData.customerId || '' : ''
    },
    /**
     * 详情ID
     */
    detailId() {
      return this.id || this.$route.query.id || null
    }
  },
  watch: {
    isCreate(newVal) {
      !newVal && (this.actionData = {})
    }
  },
  methods: {
    getPageInsertList() {
      const params = {
        module: 3, // 模块  1 线索  2 客户  3 联系人
        businessId: this.detailId,
        platform: 1 // 端  1 PC  2 移动
      }
      crmPagesInsertDetailListAPI(params).then(res => {
        this.pagesInsertList = res.data || []
        this.pagesInsertComplete = true
      }).catch(() => {
        this.pagesInsertComplete = true
      })
    },
    /**
     * 详情
     */
    getDetial() {
      this.loading = true
      const params = {
        contactsId: this.detailId
      }
      if (this.poolId) {
        params.poolId = this.poolId
      }
      crmContactsReadAPI(params)
        .then(res => {
          this.loading = false
          const resData = res.data || {}
          this.detailData = resData
          this.poolAuth = resData.poolAuthList || {}
          // 负责人
          this.headDetails = [{ title: '客户名称', value: resData.customerName },
            { title: '职务', value: resData.post },
            { title: '手机', value: resData.mobile },
            { title: '创建时间', value: resData.createTime }]
        })
        .catch(() => {
          this.loading = false
          this.hideView()
        })
      crmSpecialExamineAPI({
        businessType: 1, // 业务类型  1 联系人  2 企业
        businessId: this.detailId
      }).then(res => {
        this.examineButtons = res.data.filter(item => !!item.canInitiate)
      })
    },

    /**
     * 关闭
     */
    hideView() {
      this.$emit('hide-view')
    },

    // /**
    //  * 编辑成功
    //  */
    // editSaveSuccess() {
    //   this.$emit('handle', { type: 'save-success' })
    //   this.getDetial()
    // }
    /**
     * 审批
     */
    handleExamineClick(info) {
      // 转为KP/取消KP/精准联系人
      if (info.examineCode === 'cancelKP') {
        this.showExamineRemark = true
        Object.assign(this.examineInfo, info)
      } else if (info.examineCode === 'transAccurateContact') {
        this.isCreate = true
        this.actionData = { specialExamine: true, isTrans: 1 }
      } else {
        this.$confirm(`是否发起${info.examineName}审批?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.postSpecialExamine(info.examineType, { contactsIds: this.detailId }, info.examineId, this.detailData.name, '', () => {
            // 更新详情
            this.getDetial()
            this.getTagInfo()
          })
        })
      }
    },
    // 取消KP填写完取消理由
    examineRemarkComplete(remark) {
      this.postSpecialExamine(this.examineInfo.examineType, { contactsIds: this.detailId }, this.examineInfo.examineId, this.detailData.name, remark, () => {
        this.showExamineRemark = false
        // 更新详情
        this.getDetial()
        this.getTagInfo()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/crmdetail.scss";

.wk-circle-password {
  padding: 2px;
  margin-left: 5px;
  font-size: 12px;
  color: white;
  background-color: #f56c6c;
  border-radius: 3px;
  transform: scale(0.6);
}
</style>
